<template>
  <table class="w-full text-left">
    <thead>
      <tr>
        <th v-if="language == 'en'">Assessment ID</th>
        <th v-else>评估者ID编号</th>

        <th v-if="language == 'en'">Order ID</th>
        <th v-else>Order ID</th>

        <th v-if="language == 'en'">Status</th>
        <th v-else>Status</th>

        <th v-if="language == 'en'">Created At</th>
        <th v-else>Created at</th>

        <th v-if="language == 'en'">Completed At</th>
        <th v-else>Completed at</th>

        <th class="text-center" v-if="language == 'en'">Actions</th>
        <th class="text-center" v-else>操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(order, index) in orders" :key="index">
        <td>{{order.assessment_id}}</td>

        <td>{{order.id}}</td>

        <td>{{order.state}}</td>

        <td>{{order.created_at.split('T')[0]}}</td>

        <td>{{completedAt(order.completed_at)}}</td>

        <td class="text-center">
          <a class="cursor-pointer" v-if="language == 'en'" @click="gotoOrder(order)">View</a>
          <a class="cursor-pointer" v-else @click="gotoOrder(order)">浏览</a>
          <span v-if="order.state == 'cart'">
            |
            <a
              class="cursor-pointer"
              v-if="language == 'en'"
              @click="$emit('deleteOrder', order)"
            >Delete</a>
            <a class="cursor-pointer" v-else @click="$emit('deleteOrder', order)">删除</a>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["orders", "language"],
  methods: {
    completedAt(val) {
      if (!val) {
        return "N/A";
      }

      return val.split("T")[0];
    },
    gotoOrder(order) {
      switch (order.state) {
        case "cart":
          window.location.href = `checkout?order=${order.id}`;
          break;
        default:
          window.location.href = ``;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767px) {
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    table-layout: fixed;
  }

  tr {
    background-color: #eff8ff80;
  }

  tbody {
    background-color: #f9faff;
  }

  td,
  th {
    text-align: left;
    word-break: break-word;
    border: 1px solid rgba(52, 144, 220, 0.5);
    width: 20%;
    padding: 0.5em;
  }

  a.cursor-pointer {
    display: block;
  }
}
</style>